import { render, staticRenderFns } from "./AgentsSvg.vue?vue&type=template&id=f5b594d4"
import script from "./AgentsSvg.vue?vue&type=script&lang=js"
export * from "./AgentsSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports